// onInput handler to allow only numeric input
export function handleInput(event: any, maxLength: number) {
    if (event.target && event.target.value !== undefined) {
        let input = event.target.value;
        // Remove non-numeric characters
        input = input.replace(/\D/g, '');
        // Limit to maxLength
        event.target.value = input.slice(0, maxLength);
    }
};

export function base64UrlEncode(input?: string) {
    if (!input) return;
    // Encode the input string to Base64
    const base64 = btoa(input);

    // Convert Base64 to Base64 URL by replacing characters
    const base64Url = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    return base64Url;
}